var map = {
	"./active.svg": "0422",
	"./arrow.svg": "0f6b",
	"./bg.svg": "12dc",
	"./boleto.svg": "f391",
	"./btn-edite.svg": "0709",
	"./btn-hamburguer.svg": "45bf",
	"./card.svg": "3848",
	"./close.svg": "a869",
	"./download.svg": "f707",
	"./editar.svg": "2536",
	"./excluir.svg": "8096",
	"./icon-award.svg": "12a5",
	"./icon-cam.svg": "9d63",
	"./icon-check-lg.svg": "e409",
	"./icon-flash.svg": "64e2",
	"./icon-googleads.svg": "4429",
	"./icon-helmet.svg": "d178",
	"./icon-light.svg": "cac5",
	"./icon-nut.svg": "9764",
	"./icon-nuvemshop.svg": "599c",
	"./icon-pending.svg": "fcc0",
	"./icon-shopify.svg": "a0fd",
	"./icon-table-check.svg": "fe11",
	"./icon-table-close.svg": "3183",
	"./icon-tray.svg": "d030",
	"./icon-vtex.svg": "72ec",
	"./icon-vtexio.svg": "d806",
	"./icon-vtexlegacy.svg": "40a7",
	"./icone-selo-first-position.svg": "4d15",
	"./inactive.svg": "511c",
	"./layout-claro.svg": "0d8d",
	"./layout-escuro.svg": "abb2",
	"./logo-googleads.svg": "059f",
	"./logo-nuvemshop.svg": "1ebd",
	"./logo-shopify.svg": "ea70",
	"./logo-tray.svg": "7939",
	"./logo-vtex.svg": "c79f",
	"./logo-vtexio.svg": "e479",
	"./logo-vtexlegacy.svg": "834a",
	"./new-afiliados.svg": "e76f",
	"./new-categorias.svg": "1b06",
	"./new-close.svg": "f5ef",
	"./new-home.svg": "e22b",
	"./new-marcas.svg": "46fa",
	"./new-origem.svg": "d0c1",
	"./new-produtos.svg": "be9e",
	"./next.svg": "bafa",
	"./see.svg": "5db7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "765d";